<template>
  <v-container>
    <v-toolbar flat class="main-header mb-6">
      <v-toolbar-title class="main-header__title">
        <h1>Majors</h1>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items
        v-if="permissions.includes('store_api_admin-panel_majors')"
        class="main-header__contents"
      >
        <v-btn
          class="my-auto mx-1 radius-12"
          color="success"
          to="/majors/create"
        >
          <v-icon>mdi-plus-circle</v-icon>
          <span class="mx-2">Add Major</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <hr class="mb-6" />
    <v-row>
      <v-col
        v-for="(major, index) in majors"
        :key="index"
        md="3"
        sm="6"
        cols="12"
      >
        <v-card
          class="global-card radius-12"
          min-height="180px"
          :loading="loadingDataTable"
        >
          <v-card-text class="majors-article">
            <article>
              <h3 class="primary-color mb-2">
                <strong>{{ major.name || "---" }}</strong>
              </h3>
              <read-more
                class="read-more m-b-0 major-description"
                :text="major.description || '---'"
                :max-chars="20"
                more-str="more"
                less-str="less"
              />
            </article>
          </v-card-text>
          <v-card-actions class="text-center px-4 absolute-bottom">
            <router-link
              :to="`/majors/create/${major.id}`"
              class="hovering mr-3 edit"
              v-if="
                permissions.includes('update_api_admin-panel_majors_{major}')
              "
            >
              Edit
            </router-link>

            <span
              v-if="
                permissions.includes('destroy_api_admin-panel_majors_{major}')
              "
              @click="handleDelete(major, index)"
              class="hovering delete"
            >
              Delete
            </span>
            <span v-else>---</span>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      majors: [],
      loadingDataTable: false
    };
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.createTableHeaders();
    this.indexMajors();
  },
  methods: {
    indexMajors() {
      this.loadingDataTable = true;
      IndexData({ reqName: `majors` })
        .then(res => {
          const { data } = res.data;
          this.majors = data;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = ["Major Name", "Description", "Actions"];
      this.headers = TableHeaders(headersList);
    },
    handleEdit() {},
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/majors`,
            id: id
          })
            .then(() => {
              this.majors.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>
